import FeatureList from './FeatureList';

export default FeatureList;
